import React from "react";
import "./signIn.style.sass";
import {
  Alert,
  Button,
  ButtonToolbar,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
  Modal,
  Row,
  Col,
  Schema,
  InputGroup,
  Icon,
} from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectSignModal } from "../../redux/modals/modals.selector";
import modalsTypes from "../../redux/modals/modals.types";
import Axios from "axios";
import { SetIsDemo, SetToken, SetUser } from "../../redux/user/user.actions";
import { selectIsMain, selectMap } from "../../redux/map/map.selector";
import { SetIconsLayer } from "../../redux/map/map.actions";
import { GetCarsData, SetAllDeviceInfo } from "../../redux/cars/cars.action";
import { selectToken } from "../../redux/user/user.selector";
import { selectAllDeviceInfo } from "../../redux/cars/cars.selector";
import mapTypes from "../../redux/map/map.types";

class SignInComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      formValue: {
        pre_phone: "98",
        phone: "",
        pass: "",
      },
    };
  }

  componentDidMount() {
    // setTimeout(()=>loadCaptchaEnginge(4), 10);
    setTimeout(() => {
      // document.getElementById('reload_href').innerHTML= '&#8635';
    }, 10);
  }

  render() {
    const {
      signModal,
      toggleSing,
      setUser,
      setIsDemo,
      getToken,
      setToken,
      ToggleIsMain,
      isMain,
    } = this.props;
    const handleSubmit = () => {
      this.setState({ loading: true });
      const responsivePhoneNumber = (x) => {
        switch (x.length) {
          case 12:
            return `+${x}`;
          case 11:
            return `+98${x.split("").splice(1).join("")}`;
          case 10:
            return `+98${x}`;
          default:
            return x;
        }
      };
      let phoneVal = this.state.formValue.phone;
      const passVal = this.state.formValue.pass;
      if (this.state.formValue.pre_phone !== "98") {
        phoneVal = this.state.formValue.pre_phone + this.state.formValue.phone;
      }
      const data = {
        phone: responsivePhoneNumber(phoneVal),
        pass: passVal,
      };
      setIsDemo(responsivePhoneNumber(phoneVal));
      if (getToken) {
        setToken("");
      }

      Axios.post("https://xitonix.com/api/login", JSON.stringify(data)).then(
        (res) => {
          if (res.data.success === "true") {
            setToken(res.data.data.Server);
            setUser(data);
            this.setState({
              fromValue: {
                pre_phone: "98",
                phone: "",
                pass: "",
              },
            });
            Alert.success("باموفقیت وارد شدید", 3000);
            toggleSing();
            this.setState({ loading: false });
            if (!isMain) {
              ToggleIsMain();
            }
            // Axios.post(`${res.data.data.Server}/lastCars`, JSON.stringify(data))
            //     .then(res => {
            // setCars(res);
            // });
          } else {
            this.setState({
              loading: false,
              formValue: {
                pre_phone: "98",
                phone: "",
                pass: "",
              },
            });
            Alert.error("نام کاربری یا گذرواژه اشتباه است", 3000);
          }
        }
      );
    };

    const { StringType, NumberType } = Schema.Types;
    const model = Schema.Model({
      captcha: StringType().isRequired(),
      pass: StringType().isRequired(),
      phone: NumberType().isRequired(),
      pre_phone: NumberType().isRequired(),
    });

    return (
      <Modal
        className="signIn-modal"
        size="xs"
        show={signModal}
        onHide={() => toggleSing()}
      >
        <Modal.Header>اطلاعات کاربری خود را وارد کنید</Modal.Header>
        <Form
          formValue={this.state.formValue}
          onSubmit={() => handleSubmit()}
          model={model}
          onChange={(value) => {
            this.setState({ formValue: value });
          }}
        >
          <Modal.Body>
            <FormGroup>
              <ControlLabel>شماره تلفن</ControlLabel>
              <InputGroup>
                <FormControl
                  size="lg"
                  className="phone"
                  name="phone"
                  placeholder="شماره خود را وارد کنید ..."
                />
                <InputGroup.Addon className="pre-phone">
                  <FormControl
                    className="pre-phone2"
                    size="xs"
                    name="pre_phone"
                  />
                  <Icon icon="plus" />
                </InputGroup.Addon>
              </InputGroup>
              <HelpBlock tooltip>
                شماره تلفن همراه{" "}
                <strong style={{ color: "orange" }}>"خودتان"</strong> یا همان{" "}
                <strong style={{ color: "orange" }}>"مالک"</strong> را وارد کنید
                <br />
                بطور مثال 9190191914
              </HelpBlock>
            </FormGroup>
            <FormGroup>
              <ControlLabel>رمز عبور</ControlLabel>
              <FormControl
                size="lg"
                name="pass"
                type="password"
                placeholder="رمز عبور ..."
              />
              <HelpBlock tooltip>
                درصورت فراموشی کلمه عبور ارسال پیامک{" "}
                <strong style={{ color: "orange" }}>"رمز"</strong> به شماره
                دستگاه یا{" "}
                <strong style={{ color: "orange" }}>"درخواست رمز جدید"</strong>{" "}
                از تنظیمات اپلیکیشن
              </HelpBlock>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <ButtonToolbar>
              <Row>
                <Col xs={12}>
                  <Button
                    onClick={() => toggleSing()}
                    className="BtnClose"
                    block
                  >
                    انصراف
                  </Button>
                </Col>
                <Col xs={12}>
                  <Button
                    id="login-submit-btn"
                    type="submit"
                    value="submit"
                    className="Btn1"
                    block
                    loading={this.state.loading}
                  >
                    ورود
                  </Button>
                </Col>
              </Row>
            </ButtonToolbar>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  signModal: selectSignModal,
  getmap: selectMap,
  getToken: selectToken,
  getAllDeviceInfo: selectAllDeviceInfo,
  isMain: selectIsMain,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSing: () => dispatch({ type: modalsTypes.TOGGLE_SIGN_MODAL }),
  setUser: (data) => dispatch(SetUser(data)),
  SetIconsLayer: (layer) => dispatch(SetIconsLayer(layer)),
  setCars: (res) => dispatch(GetCarsData(res)),
  setIsDemo: (data) => dispatch(SetIsDemo(data)),
  setToken: (token) => dispatch(SetToken(token)),
  setAllDeviceInfo: (deviceInfo) => dispatch(SetAllDeviceInfo(deviceInfo)),
  ToggleIsMain: () => dispatch({ type: mapTypes.TOGGLE_IS_MAIN }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignInComponent);
